// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"378dd139","498":"002a4469"}[chunkId] + ".chunk.js";
};